//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function(module) {
  'use strict';
  module
    .controller('travelManagerAssignmentController', ['$scope', 'travelManagerAssignment', 'progressBar', 'ngDialog',
      'uiGridConstants', 'commonDialog', 'commonDialogMessage', 'organizations', 'members', '$q',
       'toastr', 'authService', 'clientSelectService', 'agencySelectService', 'toastFactory',
      function($scope, travelManagerAssignment, progressBar, ngDialog, uiGridConstants, commonDialog,
        commonDialogMessage, organizations, members, $q, toastr, authService, clientSelectService,
        agencySelectService, toastFactory
      ) {
        //variable declaration
        const progress = progressBar.getProgressBar();
        let _addTravelManagerList = [];
        let _deleteTravelManagerList = [];
        let _unassignedSnapshot = [];
        let _assignedSnapshot = [];
        $scope.ownOrgName = authService.getLoginMember().Organization.Name;

        function dialogBox(dialogMessage, dialogType) {
          ngDialog.open({
            template: dialogMessage + dialogType,
            className: 'ngdialog-theme-plain',
            plain: true,
          });
        }
        // Validate that filtered organization id is defined
        function validateOrganization() {
          const organization = clientSelectService.getSelectedClient();
          return organization.id != null && Number.isInteger(organization.id);
        };
        // Watch orgFilterService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function() {
          return clientSelectService.getSelectedClient();
        }, function(newValue, oldValue) {
          if (newValue !== oldValue) {
            clearGrids();
            setGridData();
          }
        }, true);

        function clearGrids() {
          $scope.gridUnassignedTravelManagers.data = [];
          $scope.gridUnassignedTravelManagers.totalItems = 0;
          $scope.gridAssignedTravelManagers.data = [];
          $scope.gridAssignedTravelManagers.totalItems = 0;
          $scope.unassignedGridApi.grid.selection.selectAll = false;
          $scope.assignedGridApi.grid.selection.selectAll = false;
        };

        /*function getTravelAgencyId(filterOrgId) {
          return organizations.getOrganizationById(filterOrgId).then(function(organization) {
            return organization.data.TravelAgencyId;
          });
        };*/
        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }
        // Sets both grids' data
        function setGridData() {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            if (validateOrganization()) {
              progress.start();
              // Organization to assign/unassign travel Managers to/from
              const filterOrg = clientSelectService.getSelectedClient();
              const filterOrgId = filterOrg.id;
              $scope.filterOrgName = filterOrg.name;

              const agency = agencySelectService.getSelectedAgency();

              // All Manager from loginMember's travel agency
              const promiseAll = members.getTravelManagers(agency.id);
              // Travel Manager Organizations for filtered organization
              const promiseAssigned = travelManagerAssignment.getTravelManagerOrganizationsById(filterOrgId);
              //const promiseTravelAgencyId = getTravelAgencyId(filterOrgId);
              $q.all([promiseAll, promiseAssigned]).then(function(responses) {
                if (responses[0].data.length > 0) {
                  //const travelAgencyId = responses[2];
                  // Processing
                  const assignedContext = processAssignedManagers(responses[1].data);
                  const unassignedContext = processUnassignedManagers(responses[0].data, assignedContext);
                  // Populate grids
                  clearGrids();
                  $scope.gridUnassignedTravelManagers.data = unassignedContext;
                  $scope.gridUnassignedTravelManagers.totalItems = unassignedContext.length;
                  $scope.gridAssignedTravelManagers.data = assignedContext;
                  $scope.gridAssignedTravelManagers.totalItems = assignedContext.length;
                  // Save snapshots of initial grid data
                  _unassignedSnapshot = $scope.gridUnassignedTravelManagers.data.slice(0);
                  _assignedSnapshot = $scope.gridAssignedTravelManagers.data.slice(0);
                } else {
                  toastr.warning('No content received.', 'Alert');
                }
              }, function(err) {
                dialogBox(err.statusText, commonDialog.openDialog);
              }).finally(function() {
                progress.complete();
              });
            } else {
              $scope.filterOrgName = null;
            }
          } else if (valid.agencyValid) {
            //toastFactory.toast_info('Please select a client.');
          } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
        };
        // Filter out assigned Managers from all Managers
        function processUnassignedManagers(membersInfo, assignedInfo) {
          if (!!membersInfo && !!assignedInfo) {
            // Grab MemberId's of assigned Managers
            let assignedIds = _.map(assignedInfo, 'MemberId');
            return membersInfo.filter(function(member) {
              // Select members whose MemberId's are not in the assignedIds array
              return assignedIds.indexOf(member.Id) < 0;
            }).map(function(member) {
              return {
                MemberId: member.Id,
                MemberName: member.DisplayName,
                OrganizationId: member.OrganizationId,
              };
            });
          }
        };
        // Only returns a projection
        function processAssignedManagers(assignedInfo) {
          if (!!assignedInfo) {
            return assignedInfo.map(function(travelManager) {
              return {
                MemberId: travelManager.Member.Id,
                MemberName: travelManager.Member.DisplayName,
                OrganizationId: travelManager.OrganizationId,
                TravelManagerOrganizationId: travelManager.Id,
              };
            });
          }
        };
        // addTravelManager and deleteTravelManager should only act as purely visual functions --
        // the values sent to server will depend on diff from snapshotted data at time of action.
        $scope.addTravelManager = function() {
         
          const unassignedTravelManagers = $scope.gridUnassignedTravelManagers.data.filter(function(travelManager) {          
            return _addTravelManagerList.indexOf(travelManager) === -1
          });        
       
          $scope.gridUnassignedTravelManagers.data = unassignedTravelManagers;
          $scope.gridUnassignedTravelManagers.totalItems =  unassignedTravelManagers.length;

          const assignedManagers = $scope.gridAssignedTravelManagers.data.concat(_addTravelManagerList);
          $scope.gridAssignedTravelManagers.data = assignedManagers;
          $scope.gridAssignedTravelManagers.totalItems = assignedManagers.length;
       
          // Clear _addTravelManagerList
          _addTravelManagerList.length = 0;
          // Deselect left-side selectAll checkbox
          $scope.unassignedGridApi.grid.selection.selectAll = false;
        };
        $scope.deleteTravelManager = function() {
          const assignedTravelManagers = $scope._deleteTravelAgentList.data.filter(function(deleteTravelManager) {          
            return $scope.gridAssignedTravelManagers.data.indexOf(deleteTravelManager) === -1
          });  
          $scope.gridAssignedTravelManagers.data = assignedTravelManagers;
          $scope.gridAssignedTravelManagers.totalItems = assignedTravelManagers.length;

          const unassignedManagers = $scope.gridUnassignedTravelManagers.data.concat(_deleteTravelAgentList);

          $scope.gridUnassignedTravelManagers.data = unassignedManagers;
          $scope.gridUnassignedTravelManagers.totalItems = unassignedManagers.length;

          /*_deleteTravelManagerList.forEach(function(delManager) {
            // Remove row from right
            $scope.gridAssignedTravelManagers.data.splice($scope.gridAssignedTravelManagers.data.indexOf(delManager),
              1);
            $scope.gridAssignedTravelManagers.totalItems--;
            // Push row to left
            $scope.gridUnassignedTravelManagers.data.push(delManager);
            $scope.gridUnassignedTravelManagers.totalItems++;
          });
          // Clear _deleteTravelManagerList
          _deleteTravelManagerList.length = 0;
          // Deselect right-side selectAll checkbox
          $scope.assignedGridApi.grid.selection.selectAll = false;*/
        };
        // Send changes to API
        $scope.saveTravelManagers = function() {
          if (validateOrganization()) {
            const orgId = clientSelectService.getSelectedClient().id;
            // Check diffs against snapshots
            const toAdd = _.differenceWith($scope.gridAssignedTravelManagers.data, _assignedSnapshot, _.isEqual)
              .map(function(travelManager) {
                return {
                  Id: 0,
                  MemberId: travelManager.MemberId,
                  OrganizationId: orgId,
                };
              });
            const toDelete = _.differenceWith($scope.gridUnassignedTravelManagers.data, _unassignedSnapshot, _.isEqual)
              .map(function(travelManager) {
                return {
                  TravelManagerOrganizationId: travelManager.TravelManagerOrganizationId,
                };
              });
            const promiseAdd = travelManagerAssignment.addTravelManagerOrganizations(toAdd)
              .then(function(response) {
                return !!response;
              });
            const promiseDel = travelManagerAssignment.deleteTravelManagerOrganizations(toDelete)
              .then(function(response) {
                return !!response;
              });
            let promises = [];
            if (toAdd.length > 0) {
              promises.push(promiseAdd);
            }
            if (toDelete.length > 0) {
              promises.push(promiseDel);
            }
            if (promises.length > 0) {
              progress.start();
              $q.all(promises).then(function(responses) {
                progress.complete();
                if ((responses.length === 2 && responses[0] && responses[1]) || (responses.length === 1 &&
                    responses[0])) {
                  toastr.success('Changes were successfully made.', 'Success');
                  setGridData();
                } else {
                  toastr.error('An error occurred while making changes.', 'Error');
                }
              });
            } else {
              toastr.info('No changes were made.', 'Info');
            }
          }
        };
        // Resync grid data with server
        $scope.reset = function() {
          clearGrids();
          setGridData();
          _addTravelManagerList.length = 0;
          _deleteTravelManagerList.length = 0;
          if (validateOrganization()) {
            toastr.info('Grids were reset.', 'Reset');
          }
        };
        // ui-grid below        
        const columnDefs = [{
          name: 'MemberName',
          displayName: 'Travel Manager',
          visible: true,
          enableHiding: false,
          enableSorting: true,
          sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
          enableFiltering: true,
          enableColumnResizing: true,
          sort: {
            direction: uiGridConstants.ASC,
            priority: 0,
          },
        }, ];
        const gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: false,
          paginationPageSize: 25,
          useExternalPagination: false,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: true,
          enableRowHeaderSelection: true,
          multiSelect: true,
          enableSelectionBatchEvent: true,
          columnDefs: columnDefs,
        };
        /* TODO: enableFullRowSelection not working as intended:
        see https://github.com/angular-ui/ui-grid/issues/2254, https://github.com/angular-ui/ui-grid/commit/679b615bd19ff71ff1e835d7f6066e7a919f279a
        */
        // Left grid (Unassigned Managers)
        $scope.gridUnassignedTravelManagers = _.cloneDeep(gridOptions);
        $scope.gridUnassignedTravelManagers.onRegisterApi = function(gridApi) {
          $scope.unassignedGridApi = gridApi;
          gridApi.selection.on.rowSelectionChanged($scope, function(row) {
            if (row.isSelected) {
              _addTravelManagerList.push(row.entity);
            } else {
              _addTravelManagerList.splice(_addTravelManagerList.indexOf(row.entity), 1);
            }
          });
          // Handle mass selection events
          gridApi.selection.on.rowSelectionChangedBatch($scope, function(rows) {
            _addTravelManagerList = gridApi.selection.getSelectedRows();
          });
        };
        // Right grid (Assigned Managers)
        $scope.gridAssignedTravelManagers = _.cloneDeep(gridOptions);
        $scope.gridAssignedTravelManagers.onRegisterApi = function(gridApi) {
          $scope.assignedGridApi = gridApi;
          gridApi.selection.on.rowSelectionChanged($scope, function(row) {
            if (row.isSelected) {
              _deleteTravelManagerList.push(row.entity);
            } else {
              _deleteTravelManagerList.splice(_deleteTravelManagerList.indexOf(row.entity), 1);
            }
          });
          // Handle mass selection events
          gridApi.selection.on.rowSelectionChangedBatch($scope, function(rows) {
            _deleteTravelManagerList = gridApi.selection.getSelectedRows();
          });
        };
        // End ui-grid
        setGridData();
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/travelManagerAssignementController.js